/* ==========================================================================
   SkyClean Drones – kleine Bedienlogik
   Zwei Dinge, sonst nichts: Fragen aufklappen und Videos starten/anhalten.

   Grundsatz: Ohne dieses Skript ist die Seite vollständig. Die Klasse
   .scd-js auf <html> wird hier gesetzt; das CSS nutzt sie, um Antworten
   erst dann einzuklappen, wenn das Aufklappen auch funktioniert.
   ========================================================================== */
(function () {
  'use strict';

  var html = document.documentElement;
  html.classList.add('scd-js');

  /* ------------------------------------------------------------- Fragen -- */
  function initFaq() {
    document.querySelectorAll('[data-scd-faq]').forEach(function (root) {
      root.querySelectorAll('.scd-faq__q').forEach(function (btn) {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        btn.addEventListener('click', function () {
          var open = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', String(!open));
          panel.setAttribute('data-open', String(!open));
        });
      });
    });
  }

  /* -------------------------------------------------------------- Video --
     Kein Autoplay. Das Video startet, wenn der Besucher es will, oder –
     wenn Bewegung erlaubt ist – sobald es wirklich im Bild ist. Damit
     lädt niemand 4 MB, der nie so weit scrollt.                            */
  function initMedia() {
    var frames = Array.prototype.slice.call(document.querySelectorAll('[data-scd-media]'));
    if (!frames.length) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    frames.forEach(function (frame) {
      var video = frame.querySelector('[data-scd-video]');
      var btn = frame.querySelector('[data-scd-media-toggle]');
      var label = frame.querySelector('[data-scd-media-label]');
      if (!video) return;

      function setState(playing) {
        if (btn) btn.setAttribute('aria-pressed', String(playing));
        if (label) label.textContent = playing ? 'Anhalten' : 'Abspielen';
      }

      function play() {
        video.play().then(function () { setState(true); }).catch(function () { setState(false); });
      }
      function pause() { video.pause(); setState(false); }

      if (btn) {
        btn.addEventListener('click', function () {
          if (video.paused) { video.preload = 'auto'; play(); } else { pause(); }
        });
      }

      video.addEventListener('play', function () { setState(true); });
      video.addEventListener('pause', function () { setState(false); });

      /* Automatisch starten nur, wenn Bewegung erlaubt ist und der
         Abschnitt wirklich zu sehen ist – und wieder anhalten, sobald er
         aus dem Bild läuft. */
      if (!reduced.matches && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              video.preload = 'auto';
              play();
            } else if (!video.paused) {
              pause();
            }
          });
        }, { threshold: 0.4 });
        io.observe(frame);
      }

      /* Stellt der Besucher "Bewegung reduzieren" um, hält das Video an. */
      reduced.addEventListener('change', function () {
        if (reduced.matches) pause();
      });

      /* Tab im Hintergrund: nichts läuft weiter. */
      document.addEventListener('visibilitychange', function () {
        if (document.hidden && !video.paused) pause();
      });
    });
  }

  /* ------------------------------------------------------------- Einblenden --
     Reihenfolge ist hier das Entscheidende: Erst wenn feststeht, dass wir
     wieder einblenden KÖNNEN, darf überhaupt etwas versteckt werden.
     Deshalb setzt dieses Skript die Klasse .scd-js-reveal, und erst sie
     schaltet im CSS den Ausgangszustand "unsichtbar" ein. Fällt das Skript
     aus, bleibt die Seite sichtbar.                                        */
  function initReveal() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll('.scd-reveal'));
    if (!nodes.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var native = window.CSS && CSS.supports && CSS.supports('animation-timeline: view()');
    if (native) return;                 /* der Browser kann es selbst */
    if (!('IntersectionObserver' in window)) return;

    html.classList.add('scd-js-reveal');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    nodes.forEach(function (n) { io.observe(n); });

    /* Sicherheitsnetz: Was nach 3 Sekunden immer noch versteckt ist, wird
       sichtbar gemacht. Lieber ohne Animation als unsichtbar. */
    window.setTimeout(function () {
      nodes.forEach(function (n) { n.classList.add('is-visible'); });
    }, 3000);
  }

  function boot() { initFaq(); initMedia(); initReveal(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
